export const quiniela = {
  quinielaTitle: "Quiniela",
  quinielaHeroTitle: "Wêreldbeker-quiniela",
  quinielaSubtitle: "FIFA Wêreldbeker 2026",
  quinielaDescription: "Voorspel die uitslae van Wêreldbekers en wen pryse",
  quinielaPremiumLabel: "Wêreldbeker-kaartjie",
  quinielaMiniBanner: "Wêreldbeker-spin",
  quinielaBalance: "Saldo",
  quinielaActiveRound: "Aktiewe rondte",
  quinielaMatches: "Wedstryde",
  quinielaRounds: "Rondtes",
  quinielaLeaderboard: "Puntestand",
  quinielaMyPredictions: "My voorspellings",
  quinielaMyTickets: "My kaartjies",
  quinielaPlayTab: "Voorspel",
  quinielaTicketTab: "My kaartjie",
  quinielaRulesTab: "Reëls",
  quinielaRulesTabHint: "Vinnige gids",
  quinielaTabsNav: "Quiniela-primêre navigasie",
  quinielaHowToPlayCta: "Hoe om te speel",
  quinielaChooseTournament: "Kies toernooi",
  quinielaChooseRound: "Kies rondte",
  quinielaPlayNow: "Speel nou",
  quinielaViewTicket: "Bekyk kaartjie",
  quinielaReviewTicket: "Hersien kaartjie",
  quinielaReviewEyebrow: "Hersien",
  quinielaConfirmBet: "Bevestig weddenskap",
  quinielaEditPicks: "Wysig keuses",
  quinielaSubmit: "Dien voorspellings in",
  quinielaSubmitSuccess: "Voorspellings suksesvol ingedien",
  quinielaSubmitError: "Kon nie voorspellings indien nie",
  quinielaLoadError: "Ons kon nie wedstryde vir hierdie rondte laai nie.",
  quinielaRetry: "Probeer weer",
  quinielaTicketConfirmed: "Kaartjie bevestig.",
  quinielaTicketConfirmedTitle: "Kaartjie bevestig",
  quinielaTicketId: "Kaartjie-ID",
  quinielaTicketIdPending: "Genereer",
  quinielaConfirmedAt: "Bevestig",
  quinielaDeadline: "Voorspellingsperdatum",
  quinielaEntryFee: "Inskrywingsfooi",
  quinielaPrizePool: "Pryspoel",
  quinielaCurrentBalance: "Huidige saldo",
  quinielaBalanceAfter: "Saldo ná",
  quinielaPoints: "Punte",
  quinielaRank: "Rang",
  quinielaHomeWin: "Tuis",
  quinielaDraw: "Gelykop",
  quinielaAwayWin: "Weg",
  quinielaMatchDay: "Wedstryddag",
  quinielaGroup: "Groep",
  quinielaGroupStage: "Groepstadium",
  quinielaRound32: "Rondte van 32",
  quinielaRound16: "Rondte van 16",
  quinielaQuarterFinals: "Kwarteindstryde",
  quinielaSemiFinals: "Halfeindstryde",
  quinielaThirdPlace: "Derde plek",
  quinielaFinal: "Eindstryd",
  quinielaVs: "teen",
  quinielaPenalties: "pen",
  quinielaPrediction: "Voorspelling",
  quinielaResult: "Uitslag",
  quinielaCorrect: "Korrek",
  quinielaIncorrect: "Verkeerd",
  quinielaPending: "Hangende",
  quinielaRoundOpen: "Oop",
  quinielaRoundLocked: "Gesluit",
  quinielaRoundScored: "Gepunt",
  quinielaRoundUpcoming: "Aanstaande",
  quinielaRoundClosedTitle: "Hierdie rondte is reeds gesluit.",
  quinielaRoundClosedDescription: "Jy kan nie keuses wysig of indien nie, want hierdie rondte is gesluit.",
  quinielaNoRounds: "Geen rondtes beskikbaar",
  quinielaNoTicketYet: "Jy het nog nie 'n gelaaide kaartjie nie.",
  quinielaNoTicketDescription: "Voltooi jou 1X2-keuses en hersien jou kaartjie voordat jy bevestig.",
  quinielaStartTicket: "Begin kaartjie",
  quinielaAlreadySubmitted: "Jy het reeds voorspellings vir hierdie rondte ingedien",
  quinielaSelectAll: "Jy moet 'n voorspelling vir elke wedstryd kies",
  quinielaMissingPicks: "Jy het nog {{count}} wedstryde om te voltooi.",
  quinielaMissingPicksShort: "{{count}} keuses oor",
  quinielaTabReady: "Gereed om in te dien",
  quinielaTabWaiting: "Geen aktiewe rondte",
  quinielaTabLocked: "Keuses gesluit",
  quinielaTabPendingCount: "{{count}} oor",
  quinielaTabTicketDraft: "Konsep",
  quinielaTabTicketEmpty: "Leeg",
  quinielaTabTicketConfirmed: "Bevestig",
  quinielaTabLeaderboardLive: "Kompetisie lewendig",
  quinielaTabLeaderboardReady: "Uitslae gereed",
  quinielaTournamentLeaderboard: "Algehele puntestand",
  quinielaRoundLeaderboard: "Rondtepuntestand",
  quinielaFree: "Gratis",
  quinielaUser: "Gebruiker",
  quinielaTotalPoints: "Totale punte",
  quinielaMyPosition: "My posisie",
  quinielaYourPick: "Jou keuse",
  quinielaPredictionsLocked: "Voorspellings gesluit.",
  quinielaInsufficientBalanceTitle: "Onvoldoende saldo.",
  quinielaInsufficientBalanceDescription: "Jy benodig meer saldo om hierdie kaartjie te bevestig.",

  quinielaHowToPlayTitle: "Hoe om die Quiniela te speel?",
  quinielaHowToPlayStep1Title: "1. Kies 'n rondte",
  quinielaHowToPlayStep1Desc:
    "Kies 'n oop wedstryddag van die FIFA Wêreldbeker 2026. Elke rondte groepeer verskeie wedstryde wat op dieselfde dag gespeel word.",
  quinielaHowToPlayStep2Title: "2. Voorspel die uitslae",
  quinielaHowToPlayStep2Desc:
    "Kies vir elke wedstryd: 1 (tuiswen), X (gelykop), of 2 (wegwen). Jy moet elke wedstryd in die rondte voorspel.",
  quinielaHowToPlayStep3Title: "3. Betaal en bevestig",
  quinielaHowToPlayStep3Desc:
    "As die rondte 'n inskrywingsfooi het, sal dit van jou speelsaldo gedebiteer word wanneer jy jou voorspellings indien. Voorspellings kan nie ná indiening verander word nie.",
  quinielaHowToPlayStep4Title: "4. Verdien punte",
  quinielaHowToPlayStep4Desc:
    "Elke korrekte voorspelling is 1 punt werd. Sodra al die wedstryde in die rondte klaar is, word punte outomaties bereken.",
  quinielaHowToPlayStep5Title: "5. Kyk na die puntestand",
  quinielaHowToPlayStep5Desc:
    "Bekyk die rondtepuntestand en die algehele toernooistand. Topvoorspellers wen pryse uit die poel!",
  quinielaHowToPlayNote:
    "Voorspellings sluit voor die eerste wedstryd van elke rondte afskop. Maak seker jy dien jou keuses betyds in.",
};
